import React, { useEffect, useReducer } from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash';
import KenAutoComplete from '../../../global_components/KenAutoComplete';
import KenSelect from '../../../global_components/KenSelect';
import { intakeOptions, yearOptions } from '../AddActivity/data/data';
import { getAcademicFilter, getTermData } from '../../../Utils/apiServices';
import dayjs from '../../../Utils/dayjs';
import { useAppContext } from '../../../Utils/context';
import './components/styles.scss';

const ACTIONS = {
  UPDATE_PROGRAMS: 'updatePrograms',
  UPDATE_PROGRAM: 'updateProgram',
  UPDATE_YEAR: 'updateYear',
  UPDATE_INTAKE: 'updateIntake',
  UPDATE_TERM_OPTIONS: 'updateTermOptions',
  UPDATE_TERM: 'updateTerm',
};
const initialState = {
  program: { title: '', value: '' },
  year: dayjs().format('YYYY'),
  intake: _.upperCase(dayjs().format('MMM')),
  term: '',
  programVal: '',
  termOptions: [],
  programs: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_PROGRAMS:
      const programs = _.map(
        action.value?.['Academic Program'],
        (value, prop) => ({ ...value, value: prop, title: prop })
      );

      return {
        ...state,
        programs,
        program: { title: programs[0]?.value, value: programs[0]?.value } || {
          title: '',
          value: '',
        },
        programVal: programs[0]?.value,
      };

    case ACTIONS.UPDATE_PROGRAM:
      // clear all dependent fields and other
      return {
        ...state,
        program: { title: action.value, value: action.value },
        programVal: action.value,
        term: '',
        termOptions: [],
      };

    case ACTIONS.UPDATE_YEAR:
      return {
        ...state,
        year: action.value,
        term: '',
      };
    case ACTIONS.UPDATE_INTAKE:
      return {
        ...state,
        intake: action.value,
        term: '',
      };

    case ACTIONS.UPDATE_TERM_OPTIONS:
      return {
        ...state,
        term: '',
        termOptions: action?.value.map((t) => ({
          ...t,
          value: t.TermRecordId,
          label: t.Semester,
        })),
      };
    case ACTIONS.UPDATE_TERM:
      return {
        ...state,
        term: action.value,
      };

    default:
      return state;
  }
};

const TermSelectionFilters = function (props) {
  console.log('SessionScheduler: TermSelectionFilters 1');
  const {
    initialValues = initialState,
    onProgramChange,
    onYearChange,
    onIntakeChange,
    onTermChange,
    onAcademicData,
    setChangeIntake,
    setChangeYear,
  } = props;
  const [state, dispatch] = useReducer(reducer, initialValues);

  const {
    program,
    programVal,
    year,
    intake,
    term,
    programs = [],
    termOptions = [],
  } = state;

  const { handleSnackbarOpen } = useAppContext();
  useEffect(() => {
    // Get Academic data
    getAcademicFilter()
      .then((res) => {
        dispatch({ type: ACTIONS.UPDATE_PROGRAMS, value: res });
        onAcademicData(res);
      })
      .catch((err) => {
        console.log('TermSelctionFilter: getAcademicFilter: ', err);
      });
    // callback on success
  }, []);

  useEffect(() => {
    // get terms
    console.log('Get Term data');
    dispatch({ type: ACTIONS.UPDATE_TERM_OPTIONS, value: [] });
    if (programVal && year && intake) {
      let program = programVal;
      if (program != '' && program != undefined) {
        getTermData({ program, intake, year })
          .then((res) => {
            if (res.length) {
              dispatch({ type: ACTIONS.UPDATE_TERM_OPTIONS, value: res });
              handleSnackbarOpen('success', 'Terms available. Please select');
            } else {
              handleSnackbarOpen(
                'error',
                'No terms available. Please change selection'
              );
            }
          })
          .catch((err) => {
            console.log('Term Data: ', err);
          });
      }
    }
  }, [programVal, year, intake]);

  useEffect(() => {
    let academicProgram = sessionStorage.getItem('AcademicProgram');
    let year = sessionStorage.getItem('year');
    let intake = sessionStorage.getItem('intake');
    let program = JSON.parse(academicProgram)?.value;
    if (academicProgram && year && intake) {
      dispatch({ type: ACTIONS.UPDATE_YEAR, value: year });
      dispatch({ type: ACTIONS.UPDATE_INTAKE, value: intake });
      dispatch({ type: ACTIONS.UPDATE_PROGRAM, value: program });
      setChangeYear(year);
      setChangeIntake(intake);
    } else {
      let programPlan = sessionStorage.getItem('ProgramPlan');
      let programArray = JSON.parse(programPlan)?.title.split('-');
      if (programArray && programArray.length > 0) {
        dispatch({ type: ACTIONS.UPDATE_PROGRAM, value: program });
        dispatch({ type: ACTIONS.UPDATE_YEAR, value: programArray[0] });
        dispatch({ type: ACTIONS.UPDATE_INTAKE, value: programArray[1] });
        sessionStorage.setItem('year', programArray[0]);
        sessionStorage.setItem('intake', programArray[1]);
      }
    }
  }, [programVal, year, intake]);

  const handleProgram = (e, objVal) => {
    let value = objVal?.value;
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_PROGRAM, value });
      onProgramChange({ title: value, value: value });
      sessionStorage.setItem(
        'AcademicProgram',
        JSON.stringify({ title: value, value: value })
      );
    }
  };

  const handleYear = ({ target: { value } }) => {
    // update year
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_YEAR, value });
      onYearChange(value);
      sessionStorage.setItem('year', value);
    }
  };

  const handleIntake = ({ target: { value } }) => {
    // update intake
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_INTAKE, value });
      onIntakeChange(value);
      sessionStorage.setItem('intake', value);
    }
  };

  const handleTerm = ({ target: { value } }) => {
    // update term
    if (value) {
      dispatch({ type: ACTIONS.UPDATE_TERM, value });
      sessionStorage.setItem('term', value);
    }
  };

  useEffect(() => {
    onTermChange(term, termOptions);
  }, [term]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        {/* <KenSelect
          name="program"
          label="Academic Program"
          options={programs}
          value={program}
          dropdownColor="#ffffff"
          onChange={handleProgram}
          required={true}
        /> */}
        <div className="program-autocomplete">
          <KenAutoComplete
            name="program"
            label="Academic Program"
            options={programs}
            value={program}
            onChange={(el, value) => handleProgram(el, value)}
            required={true}
            multiple={false}
          />
        </div>
      </Grid>
      <Grid item xs={6} sm={2}>
        <KenSelect
          label="Year"
          name="year"
          options={yearOptions}
          value={year}
          dropdownColor="#ffffff"
          onChange={handleYear}
          required={true}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <KenSelect
          name="intake"
          label="Intake"
          options={intakeOptions}
          value={intake}
          dropdownColor="#ffffff"
          onChange={handleIntake}
          required={true}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <KenSelect
          name="term"
          label="Term"
          options={termOptions}
          value={term}
          dropdownColor="#ffffff"
          onChange={handleTerm}
          required={true}
        />
      </Grid>
    </Grid>
  );
};

export default TermSelectionFilters;
